import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoveTaskFilesToFileGroupService } from './move-task-files-to-file-group/move-task-files-to-file-group.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    MoveTaskFilesToFileGroupService
  ],
})
export class TaskFileGroupsModule {}
